var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeTextFieldIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09091 13.6364V8.18182H6.36364V6.36364H13.6364V8.18182H10.9091V13.6364H9.09091ZM0 20V14.5455H1.81818V5.45455H0V0H5.45455V1.81818H14.5455V0H20V5.45455H18.1818V14.5455H20V20H14.5455V18.1818H5.45455V20H0ZM5.45455 16.3636H14.5455V14.5455H16.3636V5.45455H14.5455V3.63636H5.45455V5.45455H3.63636V14.5455H5.45455V16.3636Z",
    fill: "#6D85FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeTextFieldIcon);
export default __webpack_public_path__ + "static/media/OrangeTextFieldIcon.0165a9d20358611ad9c91a347e3611a4.svg";
export { ForwardRef as ReactComponent };